import { COVERGO_ASIA_PRE_PROD, COVERGO_CA_UAT, COVERGO_XN_UAT, COVERGO_CA_PREPROD, COVERGO_XN_PREPROD, COVERGO_SAAS_DEV, COVERGO_ASIA_QA, COVERGO_CA_PROD, COVERGO_XN_PROD } from "../consts.js"

export const xn = {
	// CoverGo PROD
	"xn-uat-studio.quote.hk": { appConfig: { tenantId: "xn_uat", appId: "covergo_crm" }, envConfig: COVERGO_ASIA_PRE_PROD },

	// XN AWS DEV
	"studio.covergo-dev.xn.com": {
		appConfig: { tenantId: "xn_dev", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.covergo-dev.xn.com/graphql",
			COVERGO_FILE_SYSTEM: "https://api.covergo-dev.xn.com/api/v1/files",
		},
	},

	// XN AWS UAT
	"studio.covergo-uat.xn.com": {
		appConfig: { tenantId: "xn_uat", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.covergo-uat.xn.com/graphql",
			COVERGO_FILE_SYSTEM: "https://api.covergo-uat.xn.com/api/v1/files",
		},
	},

	// XN AWS PROD
	"studio.covergo.xn.com": {
		appConfig: { tenantId: "xn", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.covergo.xn.com/graphql",
			COVERGO_FILE_SYSTEM: "https://api.covergo.xn.com/api/v1/files",
		},
	},
}

export const xn_dev = {
	"xn-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "xn_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
}

export const xn_uat = {
	"xni-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "xni",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-xn-uat",
		},
	},
	"studio.uat.xni.ca.covergo.net": {
		appConfig: {
			tenantId: "xni",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_XN_UAT,
		fileSystem: {
			bucketName: "xn-cace1-uat-xn-uat",
		},
	},
}

export const xn_qa = {
	"xni-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "xni_qa",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-xni-qa",
		},
	},
}

export const xn_preprod = {
	"xni-studio.preprod.ca.covergo.cloud": {
		appConfig: {
			tenantId: "xni_preprod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_PREPROD,
		fileSystem: {
			bucketName: "covergo-cace1-preprod-xn-preprod",
		},
	},
	"studio.preprod.xni.ca.covergo.net": {
		appConfig: {
			tenantId: "xni_preprod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_XN_PREPROD,
		fileSystem: {
			bucketName: "xn-cace1-preprod-xn-preprod",
		},
	},
}

export const xn_prod = {
	"xni-studio.ca.covergo.com": {
		appConfig: {
			tenantId: "xni_prod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_PROD,
		fileSystem: {
			bucketName: "covergo-cace1-prod-xni",
		},
	},
	"studio.xni.ca.covergo.net": {
		appConfig: {
			tenantId: "xni_prod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_XN_PROD,
		fileSystem: {
			bucketName: "xn-cace1-prod-xn-prod",
		},
	},
}
